// apply.ts must be imported first: it loads CSS tokens and applies the theme
// class to <html> before palette/index.ts reads CSS vars via getComputedStyle()
import './tokens/apply'
import './augmentations'
import { createTheme, Theme } from '@mui/material/styles'
import { buildPalette } from './palette'
import typography from './typography'
import components from './components'
import { THEME_CONSTANTS } from './tokens/constants'

export function createAppTheme(): Theme {
  return createTheme({
    spacing: THEME_CONSTANTS.SPACING,
    palette: buildPalette(),
    typography,
    components
  })
}

const theme = createAppTheme()

export { default as PaletteTheme, PaletteType } from './palette'
export { THEME_CONSTANTS } from './tokens/constants'
export default theme
